import React from "react";
import "./depositWarningDialog.less";
import ButtonUI from "@/componentsUI/Button";
import PopupMask from "@/componentsUI/PopupMask";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";

interface DepositWarningDialogProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DepositWarningDialog: React.FC<DepositWarningDialogProps> = ({
  visible,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslationPlus("Wallet");

  return (
    <PopupMask visible={visible} onClose={onClose}>
      <div className="deposit-warning-dialog">
        <div className="dialog-header">
          <h3 className="dialog-title">{t("DepositWarningTitle")}</h3>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="dialog-content">
          <p dir="auto">{t("DepositWarningBody")}</p>
        </div>
        <div className="dialog-footer">
          <ButtonUI type="primary" onClick={onConfirm} className="confirm-btn">
            {t("Confirm")}
          </ButtonUI>
        </div>
      </div>
    </PopupMask>
  );
};

export default DepositWarningDialog;
